import { DialogComponent } from '@theme/dialog';

/**
 * A dialog that opens itself automatically after a configurable delay, and
 * remembers whether it has already been shown according to a frequency setting.
 *
 * @extends DialogComponent
 */
export class PopupTimed extends DialogComponent {
  /** @type {number | undefined} */
  #timeoutId;

  connectedCallback() {
    super.connectedCallback();

    if (this.#alreadyShown) return;

    this.#timeoutId = window.setTimeout(() => {
      this.showDialog();
      this.#markShown();
    }, this.delay);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.clearTimeout(this.#timeoutId);
  }

  get delay() {
    return Number(this.getAttribute('delay')) || 0;
  }

  get frequency() {
    return this.getAttribute('frequency') || 'once_session';
  }

  get storageKey() {
    return this.getAttribute('storage-key') || 'popup-timed';
  }

  get #alreadyShown() {
    const last = Number(window.localStorage.getItem(this.storageKey));
    if (!last) return false;
    const MONTH_IN_MS = 30 * 24 * 60 * 60 * 1000;
    return Date.now() - last < MONTH_IN_MS;
  }

  #markShown() {
    window.localStorage.setItem(this.storageKey, Date.now().toString());
  }
}

if (!customElements.get('popup-timed-component')) {
  customElements.define('popup-timed-component', PopupTimed);
}
